import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ClientConfiguration } from "./configTypes"

interface ConfigState {
    clientConfiguration: ClientConfiguration | null
}

const initialState: ConfigState = {
    clientConfiguration: null,
}

const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        setConfigData(state, action: PayloadAction<ClientConfiguration>) {
            state.clientConfiguration = action.payload
        },
        clearConfigData(state) {
            state.clientConfiguration = null
        },
    },
})

export const { setConfigData, clearConfigData } = configSlice.actions

export const configReducer = configSlice.reducer
